import React from 'react';
const Footer = () =>{
    return(
        <div className="footer"><p>© Copyright {new Date().getFullYear()}. All rights reserved.</p></div>
    );
}
export default Footer;